import * as React from 'react';
import { useFrameHooks } from '@xingternal/hub';
const listOfAlias = {
    START: '/network-home',
    DISCOVER: '/discover/explore',
    YOU: '/notification-center',
    JOBS: '/jobs',
};
const InternalLink = ({ to, toAlias, queryParams = '', ...props }) => {
    const { useLinkComponent } = useFrameHooks();
    const A = ({ to, ...props }) => (React.createElement("a", { href: to, ...props }));
    const getFallbackComponent = () => A;
    const getComponent = (useLinkComponent || getFallbackComponent);
    if (toAlias !== undefined) {
        // @TODO: Figure out when to throw an error vs fallback to an anchor tag
        if (typeof toAlias !== 'string') {
            throw new Error(`invalid toAlias prop provided: ${toAlias}`);
        }
        if (!Object.keys(listOfAlias).includes(toAlias)) {
            throw new Error(`unregistered toAlias prop provided: ${toAlias}`);
        }
        const url = `${listOfAlias[toAlias]}${queryParams}`;
        const Component = getComponent(url);
        return React.createElement(Component, { to: url, ...props });
    }
    if (to !== undefined) {
        if (typeof to === 'string') {
            const Component = getComponent(to);
            return React.createElement(Component, { to: to, ...props });
        }
        // If `to` is defined, but not a string url, we assume it's a Router's to configuration object
        const Component = getComponent(true);
        return React.createElement(Component, { to: to, ...props });
    }
    // This case catches props `onClick` only and `href` only
    const Component = getComponent(false);
    return React.createElement(Component, { ...props });
};
export const Link = InternalLink;
//# sourceMappingURL=index.js.map